import api from '@/lib/api'

export interface DomainSettings {
  timezone?: string
  date_format?: string
  distance_unit?: 'km' | 'mi' | 'miles'
  speed_unit?: 'kmh' | 'mph' | 'kmph'
  currency?: string
  map_provider?: 'google' | 'osm' | string
  idle_threshold_minutes?: number
  trip_min_distance_meters?: number
  overspeed_threshold_kmh?: number
  overspeed_threshold_kmph?: number
  unreachable_threshold_minutes?: number
  data_retention_days?: number
  theme?: Record<string, unknown>
  [key: string]: unknown
}

/**
 * Fetch the current tenant domain settings.
 * The `theme` sub-object is used by ThemeProvider to apply branding.
 */
export const getSettings = () =>
  api
    .get<{ success: true; data: DomainSettings }>('/settings')
    .then((r) => r.data.data)

/** Update domain settings (partial update). */
export const updateSettings = (body: Partial<DomainSettings>) =>
  api
    .put<{ success: true; data: DomainSettings }>('/settings', body)
    .then((r) => r.data.data)
